module.exports = __webpack_public_path__ + "static/media/car.cc9259a2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/car.pdf
// module id = 2050
// module chunks = 0